import { TimePicker } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateField,
  useFormData,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";

import { StyledTimePicker } from "./styles";

interface TimePickerProps {
  fieldId: string;
}

function TimePickerField({ fieldId }: TimePickerProps) {
  const findFieldById = useFormData((fd) => fd.findFieldById);
  const { translatorFor, dataTestIdPrefix } = useFormDataContext();

  const field = findFieldById(fieldId);

  const value = field.value.asString();
  const currentTime = value.value() || value.defaultValue();
  const timeValue = currentTime ? dayjs(currentTime, "HH:mm") : null;

  const writable = field.writable;

  const translator = translatorFor(field);
  const label = translateField(translator, field, Suffix.LABEL);

  const handleTimeChange = (newValue: Dayjs | null) => {
    const newTime = newValue?.format("HH:mm") || "";
    field.setValue(newTime);
  };

  return (
    <StyledTimePicker>
      <TimePicker
        dataTestId={`${dataTestIdPrefix}-${field.id()}`}
        label={label.toString()}
        isDisabled={!writable}
        onChange={handleTimeChange}
        value={timeValue}
      />
    </StyledTimePicker>
  );
}

export default TimePickerField;
